import React, { Component, Fragment } from 'react';
import { Collapse, Divider, Input, Select, Tooltip } from 'antd';
import EditableTable from '../EditableTable';
import MaskInput from '../MaskInput';
import TagsInput from '../TagsInput';
import { SortFn } from '@/services/helper/sort';
import { DriverPoints, ReceiverPoints, getDefaultList, dataRateOptionList } from '@/services/Andes_v2/constants.js';
import { CPHY } from '@/services/PCBHelper/constants';
import { getValue, INSERTIONLOSS, RETURNLOSS, COMRETURN, DIFFTOCOM, CROSSCOUPLING, getFrequencyLabel } from '@/services/helper/reportHelper';
import { PCIE } from '@/services/PCBHelper/constants';
import { numberCheck } from '@/services/helper/dataProcess';
import "./index.css";

const Driver = "Driver", Receiver = "Receiver";
const referenceLinesColumns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    width: 150,
    ellipsis: true
  },
  {
    title: 'Channel Spec (dB@GHz)',
    dataIndex: 'points',
    key: 'points',
    width: 170,
    ellipsis: true
  },
  {
    title: 'Driver Spec (dB@GHz)',
    dataIndex: DriverPoints,
    key: DriverPoints,
    width: 170,
    ellipsis: true
  },
  {
    title: 'Receiver Spec (dB@GHz)',
    dataIndex: ReceiverPoints,
    key: ReceiverPoints,
    width: 170,
    ellipsis: true,
  },
  {
    title: 'Magnitude (dB)',
    dataIndex: 'y',
    key: 'y',
    width: 100,
    ellipsis: true
  },
  {
    title: 'Frequency (GHz)',
    dataIndex: 'x',
    key: 'x',
    width: 100,
    ellipsis: true
  }
]

/**
 * @description ReferenceLines component
 * @param {type,tableData,interfaceType,guideValue,guideKey,[isXTable],[dataRate],[symbolRate],[driver],[receiver],[frequency],[components],
 * ,changeTableData,[changeConfigs],changeSettingInfo,[changeResultData]} props
 */
class ReferenceLines extends Component {
  constructor(props) {
    super(props);
    this.state = {
      referenceLinesColumns: [],
      error: '',
      updateMaskTypes: [],
      errorMsg: {},
      editInputInfo: { type: '', value: '' },
    }

    this.refInput = {};
    this.dialogRoot = document.getElementById('root');
  }

  componentDidMount() {
    this.getColumns();
  }

  getColumns = () => {
    referenceLinesColumns.forEach((column) => {
      if (column.key === 'name') {
        column.render = (value, record) => {
          const name = getValue(value)
          return <span>{name}</span>;
        }
      } else if (column.key === 'x') {
        column.render = (value, record) => {
          return this.InputValueRender(record, value ? value : [], 'x');
        }
      } else if (column.key === 'y') {
        column.render = (value, record) => {
          return this.InputValueRender(record, value ? value : [], 'y');
        }
      } else if (['points', DriverPoints, ReceiverPoints].includes(column.key)) {
        column.render = (value, record) => {
          const { updateMaskTypes } = this.state;
          const { symbolRate, frequency, interfaceType, isEdit } = this.props;
          return (
            <MaskInput
              maskList={value}
              typeName={getValue(record.name)}
              dataRate={record.dataRate}
              width='100%'
              type={record.name}
              interfaceType={interfaceType}
              changeMaskList={(params) => this.changeList({ inputType: column.key, ...params })}
              symbolRate={symbolRate}
              frequency={frequency}
              pointType={column.key}
              cphyInsertionLossSpec={record.cphyInsertionLossSpec || 'Short'}
              updateMaskTypes={updateMaskTypes}
              changeUpdateMaskTypes={this.changeUpdateMaskTypes}
              isEdit={isEdit}
            />
          );
        }
      }
    })
  }

  InputValueRender = (record, value, inputType) => {
    return <TagsInput
      tagList={value}
      className="reference-line-line-tags"
      type={`${record.name}_${inputType}`}
      allowedDuplicates={true}
      width='100%'
      changeTagList={(_, list) => this.changeList({ list, inputType, type: record.name })}
      displayInput={true}
      tagInputBlur={() => this.tagInputBlur(inputType, record.name)}
    />
  }

  changeList = ({ list, inputType, type, cphyInsertionLossSpec, isChangeCPHYInsertionLossSpec = false }) => {
    if (isChangeCPHYInsertionLossSpec) {
      this.changeCPHYInsertionLossSpec(type, list, cphyInsertionLossSpec);
      return;
    }

    let error = '', _list = [];
    list.forEach(item => {
      if (['points', DriverPoints, ReceiverPoints].includes(inputType)) {
        const data = item
        if (data) {
          _list.push(data)
        }
      } else if (!numberCheck(item)) {
        const numberData = Number(item);
        if ((inputType === 'x' && numberData < 0) || (inputType === 'y' && numberData > 0)) {
          error = 'Data needs to be positive.';
        } else {
          const data = (parseFloat(numberData.toFixed(2))).toString()
          if (data) {
            _list.push(data)
          }
        }
      } else {
        error = 'The value entered must be a number.'
      }
    })

    _list = [...new Set(_list)];

    if (!error) {
      if (['points', DriverPoints, ReceiverPoints].includes(inputType) || _list.length < 6) {
        this.changeResultData(inputType, type, _list)
      } else {
        error = 'Input data cannot exceed five.'
      }
    }
    if (error) {
      this.setState({ error })
      setTimeout(() => {
        this.setState({ error: null })
      }, 3000)
    }
  }

  changeDataRate = (dataRate) => {
    const { tableData, interfaceType } = this.props;
    let _tableData = [...tableData];
    _tableData.forEach(item => {
      if (interfaceType === PCIE && (item.name === INSERTIONLOSS || item.name === RETURNLOSS || item.name === COMRETURN)) {
        const defaultList = getDefaultList({ interfaceType, type: item.name, dataRate });
        item.points = [...defaultList];
      }
    })

    this.props.changeConfigs && this.props.changeConfigs(_tableData, { dataRate }, "points", ["points"]);
    this.props.changeTableData(_tableData);
    this.props.changeSettingInfo({ dataRate });
  }

  changeCPHYInsertionLossSpec = (type, list, cphyInsertionLossSpec) => {
    const { tableData } = this.props;
    let _tableData = [...tableData];
    const index = _tableData.findIndex(item => item.name === type);
    if (index > -1) {
      _tableData[index].cphyInsertionLossSpec = cphyInsertionLossSpec;
      _tableData[index].points = list;

      this.props.changeTableData(_tableData);
    }
  }

  tagInputBlur = (inputType, type) => {
    const { guideValue = [] } = this.props;
    const list = (guideValue.find(item => item.name === type) || {})[inputType]
    if (list && list.length) {
      const errors = list.filter(item => !!numberCheck(item))
      if (errors && errors.length) {
        const _list = list.filter(item => !numberCheck(item))
        this.changeResultData(inputType, type, _list)
      }
    }
  }

  changeResultData = (inputType, type, list) => {
    const { isXTable, tableData } = this.props;
    let _isXTable = isXTable;
    let _tableData = [...tableData], disabled = true;
    _tableData.forEach(item => {
      if (item.name === type) {
        item[inputType] = list
      }
      if (item.x.length) {
        disabled = false
      }
    })

    if (disabled && _isXTable) {
      _isXTable = false
    }

    this.props.changeTableData(_tableData);
    this.props.changeResultData && this.props.changeResultData(_tableData, isXTable, inputType);
  }

  changeUpdateMaskTypes = (updateMaskTypes) => {
    this.setState({ updateMaskTypes })
  }

  // paramsInfo = { symbolRate, frequency, driver, receiver }
  changeConfigs = (changeType, pointType = "points", paramsInfo = {}) => {
    const { tableData, symbolRate: propsSymbolRate, frequency: propsFrequency, driver: propsDriver, receiver: propsReceiver, interfaceType } = this.props;

    const symbolRate = paramsInfo.symbolRate || propsSymbolRate,
      frequency = paramsInfo.frequency || propsFrequency,
      driver = paramsInfo.driver || propsDriver,
      receiver = paramsInfo.receiver || propsReceiver;

    let _tableData = [...tableData];
    let pointTypes = [pointType];
    _tableData.forEach(item => {
      if ((['fh', 'symbolRate'].includes(changeType) && item.name === COMRETURN) || (['fMax', 'symbolRate'].includes(changeType) && [CROSSCOUPLING, DIFFTOCOM].includes(item.name)) || (changeType === 'fLPMax' && item.name === CROSSCOUPLING)) {
        const defaultList = getDefaultList({ interfaceType, type: item.name, symbolRate, cphyInsertionLossSpec: item.cphyInsertionLossSpec, ...frequency });
        item.points = [...defaultList];
      }
      if (['fh', 'fMax', 'fLPMax', 'symbolRate'].includes(changeType) && item.name === RETURNLOSS) {
        const defaultDriverList = getDefaultList({ interfaceType, type: item.name, symbolRate, pointType: 'driverPoints', ...frequency });
        item.driverPoints = [...defaultDriverList];
        !pointTypes.includes(DriverPoints) && pointTypes.push(DriverPoints);
      }
      if (
        (['fh', 'symbolRate'].includes(changeType) && item.name === RETURNLOSS)
        || (['fMax', 'symbolRate'].includes(changeType) && [RETURNLOSS, COMRETURN, DIFFTOCOM].includes(item.name))
        || (changeType === 'fINTMin' && item.name === COMRETURN)
        || (changeType === 'fLPMax' && item.name === RETURNLOSS)) {
        const defaultReceiverList = getDefaultList({ interfaceType, type: item.name, symbolRate, pointType: 'receiverPoints', ...frequency });
        item.receiverPoints = [...defaultReceiverList];
        !pointTypes.includes(ReceiverPoints) && pointTypes.push(ReceiverPoints);
      }
    })
    this.props.changeTableData(_tableData);
    this.changeUpdateMaskTypes([RETURNLOSS, COMRETURN, DIFFTOCOM, CROSSCOUPLING])

    this.props.changeConfigs && this.props.changeConfigs(_tableData, { symbolRate, driver, receiver, frequency }, pointType, pointTypes);
  }

  changeSymbolRate = () => {
    const { frequency } = this.props;
    const { errorMsg, editInputInfo } = this.state;
    const { value } = editInputInfo;

    const error = numberCheck(value, true);
    if (error) {
      if (this.refInput && this.refInput.symbolRate) {
        this.refInput.symbolRate.focus();
      }
      this.setState({ errorMsg: { ...errorMsg, symbolRate: error }, editInputInfo });
      return;
    } else {
      // reset fMax，fh
      const settingInfo = {
        symbolRate: value,
        frequency: {
          ...frequency,
          fh: parseFloat((value * 0.5).toFixed(3)),
          fMax: parseFloat((value * 0.75).toFixed(3))
        }
      }
      this.setState({ errorMsg: { ...errorMsg, fh: null, fMax: null, symbolRate: null }, editInputInfo: {} })
      this.changeConfigs("symbolRate", "points", settingInfo);
      this.props.changeSettingInfo(settingInfo);
    }
  }

  changeFrequency = () => {
    const { frequency } = this.props;
    const { errorMsg, editInputInfo } = this.state;
    const { type, value } = editInputInfo;
    const error = numberCheck(value, true);
    if (error) {
      if (this.refInput && this.refInput[type]) {
        this.refInput[type].focus();
      }
      this.setState({ errorMsg: { ...errorMsg, [type]: error }, editInputInfo });
      return;
    } else {
      this.setState({ errorMsg: { ...errorMsg, [type]: null }, editInputInfo: {} });
      this.changeConfigs(type, "points", { frequency: { ...frequency, [type]: value } });
    }
    this.props.changeSettingInfo({ frequency: { ...frequency, [type]: value } });
  }

  changeDriverOrReceiver = (value, type) => {
    const key = type === Driver ? 'driver' : 'receiver';
    this.props.changeSettingInfo({ [key]: value });
    this.changeConfigs(type, type === Driver ? DriverPoints : ReceiverPoints, { [key]: value });
  }

  changeEditInputInfo = (type, value) => {
    const { errorMsg } = this.state;
    let error = "";
    if (type && value) {
      error = numberCheck(value, true);
    }
    this.setState({ editInputInfo: { type, value }, errorMsg: { ...errorMsg, [type]: error } });
  }

  CPHYConfigRender = () => {
    const { symbolRate, frequency, driver, receiver } = this.props;
    const { errorMsg, editInputInfo } = this.state;
    const { components, type } = this.props;
    return <Fragment>
      <div className={type === 'Result' ? 'reference-line-input-box' : 'reference-line-input-library-box'}>
        <label className='reference-line-label'>Symbol Rate</label>
        <Tooltip
          title={errorMsg.symbolRate ? errorMsg.symbolRate : null}
          classNames={{ root: 'aurora-error-msg-tooltip' }}
          open={errorMsg.symbolRate ? true : false}>
          <Input
            ref={(ref) => this.refInput.symbolRate = ref}
            className='aurora-input reference-line-flex-item-select'
            value={editInputInfo.type === 'symbolRate' ? editInputInfo.value : symbolRate} addonAfter="Gsps"
            onFocus={() => this.changeEditInputInfo('symbolRate', symbolRate)}
            onChange={(e) => this.changeEditInputInfo('symbolRate', e.target.value)}
            onBlur={(e) => this.changeSymbolRate()}
            onPressEnter={(e) => this.refInput.symbolRate.blur()}
          />
        </Tooltip>
      </div>
      <div className='reference-line-select-box'>
        {type === 'Result' ? [Driver, Receiver].map((item) => {
          return <div className='reference-line-flex-item' key={item}>
            <label className='reference-line-label'>{item}</label>
            <Select
              mode="multiple"
              className='aurora-select-multiple aurora-select reference-line-flex-item-select'
              styles={{ popup: { root: { zIndex: 100000 } } }}
              value={item === Driver ? driver : receiver}
              onChange={(value) => this.changeDriverOrReceiver(value, item)}
              options={components.map(comp => ({
                value: comp.name,
                label: comp.name,
                disabled: item === Driver ? receiver.includes(comp.name) : driver.includes(comp.name)
              }))}
            />
          </div>
        }) : null}
      </div>
      <Collapse
        className='reference-line-collapse'
        items={[{
          label: "Frequency",
          key: "Frequency",
          children: [['fh', 'fMax'], ['fINTMin', 'fLPMax']].map((list) => {
            return <div key={`${list[0]}-${list[1]}`} className='reference-line-frequency-box'>
              {list.map((item) => <div className='reference-line-flex-item' key={item}>
                <label className="reference-line-frequency-title">{getFrequencyLabel(item)}</label>
                <Tooltip
                  className='aurora-error-tooltip'
                  title={errorMsg[item] ? errorMsg[item] : null}
                  classNames={{ root: 'aurora-error-msg-tooltip' }}
                  open={errorMsg[item] ? true : false}>
                  <Input
                    ref={(ref) => this.refInput[item] = ref}
                    size='small'
                    className='reference-line-frequency-flex-item-input'
                    addonAfter="GHz"
                    value={editInputInfo.type === item ? editInputInfo.value : frequency[item]}
                    onFocus={() => this.changeEditInputInfo(item, frequency[item])}
                    onChange={(e) => this.changeEditInputInfo(item, e.target.value)}
                    onBlur={() => this.changeFrequency()}
                    onPressEnter={() => this.refInput[item].blur()}
                  />
                </Tooltip>
              </div>)}
            </div>
          })
        }]}
      />
    </Fragment>
  }

  configRender = () => {
    const { type, dataRate } = this.props;
    return <div className={type === 'Result' ? 'reference-line-input-box' : 'reference-line-input-library-box'}>
      <label className='reference-line-label'>Data Rate</label>
      <Select
        value={String(dataRate)}
        className='aurora-select reference-line-flex-item-select'
        getPopupContainer={() => document.getElementById('root')}
        popupClassName='advance-mask-dataRate-select-dropdown'
        onChange={(value) => this.changeDataRate(value)}
        options={dataRateOptionList}
      />
    </div>
  }

  render() {
    const { error } = this.state;
    const { interfaceType, tableData = [], guideKey, children } = this.props;
    const sortedTableData = SortFn(tableData, guideKey, 'name');
    return <>
      {children}
      {interfaceType === CPHY ? this.CPHYConfigRender()
        : interfaceType === PCIE ? this.configRender()
          : null}
      <Divider className='reference-line-divider' />
      <EditableTable
        rowKey={(record) => record.name}
        columns={interfaceType === CPHY ? referenceLinesColumns : referenceLinesColumns.filter(item => ![DriverPoints, ReceiverPoints].includes(item.key))}
        dataSource={sortedTableData}
        size='small'
        className='reference-line-table'
      />
      {error ? <span className="aurora-error-msg-span">{error}</span> : null}
    </>
  }
}

export default ReferenceLines;